module.exports = __webpack_public_path__ + "media/images/common/kurasei-447e71fe91bbc736ee55336659fd3e22.png";